// extracted by mini-css-extract-plugin
module.exports = {"infoText":"WorkdayBasicAuthModal__infoText","infoIcon":"WorkdayBasicAuthModal__infoIcon"};